<div class="content h-fit text-center p-5 rounded-xl">
  <div class="text-lg no-select">
    {{ 'common.status.key' | translate }} : <span class="opacity-80"> {{ status | translate }}</span>
  </div>
  <div class="text-md no-select my-2 underline" *ngIf="extra">
    {{ extra }}
  </div>
</div>
